import { Map as YMap, Array as YArray } from 'yjs';

import { genRandId } from 'shared/common/utils/core.utils';
import { WidgetType } from 'shared/common/utils/widgetsUtils';
import { ManifestInitializedProps } from 'shared/types/ManifestType';

export function createNewAudioData(): ManifestInitializedProps {
  const id = genRandId();
  return [
    {
      id,
      contentObjectData: new YMap([
        ['id', id],
        ['type', WidgetType.Audio],
        ['children', new YArray()],
        ['title', ''],
        ['src', '']
      ])
    }
  ];
}
